<template>
    <section class="activity-hero">
        <div class="activity-hero-copy"><h1>{{ title }}</h1><p v-if="description">{{ description }}</p><div v-if="$slots.default" class="activity-hero-detail"><slot /></div></div>
        <AuroraArtIcon class="activity-hero-art" :name="icon" />
    </section>
</template>
<script>
import AuroraArtIcon from '@/components/auroraIcon/artIcon.vue'
export default {
    name: 'AuroraActivityHero',
    components: { AuroraArtIcon },
    props: {
        title: { type: String, required: true },
        description: { type: String, default: '' },
        icon: { type: String, default: 'gift' }
    }
}
</script>
